import { Header } from 'components/Header'
import { useIsScrollingDown } from 'hooks/useIsScrollingDown'
import React from 'react'
import { MealPlanStepper } from '../MealPlanStepper'
import { MealPlanHeaderRoot, StepperContainer, Wrapper } from './MealPlanHeader.styles'

type MealPlanHeaderProps = {}

export const MealPlanHeaderV2 = (_props: MealPlanHeaderProps) => {
  const isScrollingDown = useIsScrollingDown()
  return (
    <MealPlanHeaderRoot isScrollingDown={isScrollingDown}>
      <Header trimmed />
      <Wrapper variant="v2">
        <StepperContainer variant="v2">
          <MealPlanStepper />
        </StepperContainer>
      </Wrapper>
    </MealPlanHeaderRoot>
  )
}

MealPlanHeaderV2.displayName = 'MealPlanHeaderV2'
